module.exports = __webpack_public_path__ + "437924f8da9cde1c4fac638cc5c021d5.gif";